import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notice bg-light-success rounded border-success border border-dashed my-8 p-6"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "fs-2 text-gray-600" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = { class: "svg-icon svg-icon-3tx svg-icon-success me-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Congratulations! ")
const _hoisted_9 = { class: "px-20" }
const _hoisted_10 = { class: "row mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountDetails = _resolveComponent("AccountDetails")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_EstoreTrans = _resolveComponent("EstoreTrans")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_AccountDetails),
    (_ctx.pcpmonitoring.congrats1 != undefined && _ctx.pcpmonitoring.congrats1 != null && _ctx.pcpmonitoring.congrats1 != '')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("p", null, [
                    _hoisted_6,
                    _createVNode("span", _hoisted_7, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/GreenCheck.svg" }),
                      _hoisted_8
                    ])
                  ]),
                  _createVNode("p", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.pcpmonitoring.congrats1) + " ", 1),
                    _createVNode("u", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpmonitoring.milestoneAmount).toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.pcpmonitoring.congrats2) + " ", 1),
                    _createVNode("u", null, _toDisplayString(_ctx.pcpmonitoring.unlockedUpgradePackage) + " Package!", 1)
                  ]),
                  _createVNode("button", {
                    class: "btn btn-xl btn-primary my-3 ms-20",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pCPUpgradeConfirmation && _ctx.pCPUpgradeConfirmation(...args)))
                  }, " Upgrade Now "),
                  (_ctx.pcpmonitoring.nextMilestone != 0.00)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn btn-xl btn-warning mx-2",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pCPMilestoneIgnoreConfirmation && _ctx.pCPMilestoneIgnoreConfirmation(...args)))
                      }, " Not Now "))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_EstoreTrans)
    ]),
    _createVNode(_component_router_view)
  ], 64))
}